/** Date/report-date column detection, generalized from PriceParrotParityTool/analyzeParityCsv.ts. */
export const REPORT_DATE_HINT = 'report';
export const DATE_COLUMN_HINT = 'date';

export const LE_FLASH_COLUMN_ALIASES = ['luxuryescapes_flash', 'luxury escapes flash', 'le flash', 'le (live flash)'];
